﻿//debugger;
export var Polling = {
    enabled: false,
    Datapack: {},
    notificationList: [],

    Stop: function () {
        console.info("Polling is stopping...");
        $.each(localStorage, function (id, obj) {
            if (id.indexOf("notification_") > -1) {
                localStorage.removeItem(id);
            }
        })
        this.enabled = false;
    },
    Start: function () {
        this.enabled = true;
        console.info("Polling has been started");
        this.Poll();
    },
    Poll: async function () {
        Polling.Datapack.Interaction = 'CheckNotifications';
        let response = await fetch("/ppapi/notification");
        Polling.catchAjax(await response.json());
    },
    catchAjax: function (callback) {
        $.each(callback.NotificationList, async function (id, obj) {
            if (!checkNoteIsShown(obj.ID)) {
                localStorage.setItem("notification_" + obj.ID, true);
                SpawnToast(obj.Title, obj.Description, obj.ID, obj.CategoryID);

                let response = await fetch("/ppapi/notification/" + obj.ID, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        Interaction: "ConfirmRead",
                        ID: obj.ID,
                    }),
                });

                let result = await response.json();
                localStorage.removeItem("notification_" + result.ID);
            }
        })

        if (Polling.enabled) {
            setTimeout(Polling.Poll, 2000);
        } else {
            console.log("Polling has been stopped");
        }
    }
}